module.exports = __webpack_public_path__ + "static/media/copy.285778c3.png";